import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import add from '../../../assets/icons/backOffice/StructurePlus.svg';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconBox, IconStructureNavArrow } from '../../../styles/Icons';
import { directGoBack } from '../myTeamBackOffice.actions';
import UserComponent from '../UserComponent';

const RootTeamMemberMobile = () => {
  const dispatch = useDispatch();

  const { directBreadcrumbs, directTeamMemberInfo } = useSelector(
    (state) => state.myTeamBackoffice
  );

  const BackUser = () => {
    return (
      <>
        {directBreadcrumbs?.length > 0 && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              dispatch(directGoBack());
            }}>
            <IconBox style={{ transform: 'rotate(270deg)' }}>
              <Icon color={color.colors.neutral900}>
                <IconStructureNavArrow />
              </Icon>
            </IconBox>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div
        style={{
          width: '60px',
          position: 'absolute',
          left: 40,
          top: 'calc(50% - 30px)'
        }}>
        <BackUser />
      </div>
      {directTeamMemberInfo ? (
        <>
          <UserComponent user={directTeamMemberInfo} />
          {/* <LevelOneImgName>
            <UserImageCircle
              image={rootTeamMember?.profileImageUrl}
              avatar
              avatarSize='25px'
              size='50px'
              margin='0 0 4px 0'
            />
            <P3 mb='4'>
              {rootTeamMember?.name && rootTeamMember?.surname
                ? rootTeamMember?.name + ' ' + rootTeamMember?.surname
                : ''}
            </P3> */}

          {/* 
            {teamMember && teamMember?.isDirectUser ? (
              <P3
                center
                mb='5'
                color={color.colors.neutral900}
                style={{ maxWidth: '100%' }}
              >
                <div className='truncated'>
                  <div>{teamMember?.name}</div>
                  <span style={{ marginLeft: 6 }}>
                    {teamMember?.surname?.charAt(0)}.
                  </span>
                </div>
              </P3>
            ) : (
              <P3
                center
                mb='5'
                color={color.colors.neutral900}
                style={{ maxWidth: '100%' }}
              >
                <div className='truncated'>
                  <div>{teamMember?.username ?? `#${teamMember?.id}`}</div>
                </div>
              </P3>
            )} */}
          {/* </LevelOneImgName> */}
          {/* problem */}
          {/* <Desktop style={{ width: '100%' }}>
            <FlexCenterEqual>
              <div>
                <h3>Left team</h3>
                <h2>{rootTeamMember?.leftLegTotalVolume} VP</h2>
              </div>
              <div>
                <h3>Left team</h3>
                <h2>{rootTeamMember?.rightLegTotalVolume} VP</h2>
              </div>
            </FlexCenterEqual>
          </Desktop>
          <Mobile>
            <CaptionText color={color.colors.neutral500}>
              ID: {rootTeamMember.id}
            </CaptionText>
          </Mobile> */}
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          <img src={add} alt='' />
        </div>
      )}
    </>
  );
};

export default RootTeamMemberMobile;
